import clsx from "clsx";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, Link as RouterLink, useHistory } from "react-router-dom";

import { Grid, Typography, Divider, List, ListItem, Tabs, Tab } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { PROMO_CODE_TYPES } from "../../constants";
import { PromosContentRouter } from "../../routers/PromosContentRouter";
import { SectionGridLayout, SectionGridContainer } from "../../components/Layout";

const useStyles = makeStyles((theme) => ({
  buttonBackground: { background: theme.palette.primary.red },
  fullWidth: { width: "100%" },
  navSelected: { color: theme.palette.primary.button },
  vertDivider: { borderRight: `1px solid ${theme.palette.primary.divider}` },
  noPad: { paddingLeft: 0, paddingRight: 0 },
}));

const Promo = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [menuTab, setMenuTab] = useState(PROMO_CODE_TYPES[0]);
  const [currentTab, setCurrentTab] = useState(location.pathname.includes("/promo-groups") ? 1 : 0);
  const [showTabs, setShowTabs] = useState(true);

  const TABS = [
    { label: "AllCodes", path: `/promos/${menuTab}` },
    { label: "Groups", path: "/promo-groups" },
  ];

  useEffect(() => {
    if (location.pathname.includes("/promos")) {
      setMenuTab(PROMO_CODE_TYPES.find((type) => location.pathname.includes(type)));
      setCurrentTab(0);
    }
  }, [location.pathname]);

  const onChangeTab = (_, tab) => {
    setCurrentTab(tab);
    history.push(TABS[tab].path);
  };

  return (
    <SectionGridLayout>
      <SectionGridContainer spaceContents>
        <Grid item container xs={12} justify="space-between">
          <Grid item container alignItems="center" xs={12} md={6}>
            <Typography variant="h5">{`${t("Promos.Title")}`}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.noPad}>
          <Divider />
        </Grid>
        <Grid item container xs={12} md={2} className={classes.vertDivider}>
          <List className={classes.fullWidth}>
            {PROMO_CODE_TYPES.map((type) => (
              <ListItem
                key={type}
                button
                component={RouterLink}
                to={`/promos/${type}`}
                className={clsx(
                  menuTab === type &&
                    !location.pathname.includes("/promo-groups") &&
                    classes.navSelected,
                )}
                onClick={() => setShowTabs(true)}
              >
                {t(`Promos.Nav.${type}`)}
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={10}>
          {showTabs && (
            <Grid item xs={12} className={classes.noPadding}>
              <Tabs value={currentTab} onChange={onChangeTab} indicatorColor="secondary" centered>
                <Tab label={t("Promos.Tabs.AllCodes")} className={classes.tab} />
                <Tab label={t("Promos.Tabs.Groups")} className={classes.tab} />
              </Tabs>
              <Divider />
            </Grid>
          )}
          <PromosContentRouter handleShowTabs={setShowTabs} handleChangeTab={setCurrentTab} />
        </Grid>
      </SectionGridContainer>
    </SectionGridLayout>
  );
};

export default Promo;
